module.exports = __webpack_public_path__ + "static/polygon-desc-x2-0e23a46c347c0804a6329e612fdcc497.png";